const createLogger = () => {
  // Check both process.env.NODE_ENV and process.argv for production flag
  const isProduction = process.env.REACT_APP_NODE_ENV === 'production';

  return (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  };
};

// Create the logger instance
const log = createLogger();

export default log;
